import { getLocalItem, removeLocalItem, setLocalItem } from "src/utils/localStorage";

export type DocNavIntent = { type: "folder" } | { type: "filter"; favoriteId: number };

const KEY = "doc_nav_intent";

export function setDocNavIntent(intent: DocNavIntent): void {
  setLocalItem(KEY, intent);
}

export function peekDocNavIntent(): DocNavIntent | null {
  return getLocalItem<DocNavIntent>(KEY);
}

export function consumeDocNavIntent(): DocNavIntent | null {
  const intent = getLocalItem<DocNavIntent>(KEY);
  if (intent) {
    removeLocalItem(KEY);
  }
  return intent;
}
